import { XlsxIcon } from '../../../../assets/icons';
import { useLazyGetExampleFileQuery } from '../../../../service/referral-service';
import styles from './DisplayInputFile.module.scss'

interface FileInputProps {
    title?: string;
    description?: string;
    fileName?: string;
}

const DisplayInputFile = (props: FileInputProps) => {
    const [downloadTemplate, { isFetching }] = useLazyGetExampleFileQuery();

    return <div className={styles.container}>
        <div className={styles.header}>
            <h2 className={styles.title}>{props.title ?? ""}</h2>
            <p className={styles.description}>{props.description ?? ""}</p>
        </div>

        <div className={styles.fileDisplayContainer}>
            <div className={styles.fileNameContainer}>
                <XlsxIcon />
                <p>{props.fileName}</p>
            </div>

            <button className={styles.btn} onClick={() => downloadTemplate()} disabled={isFetching}>
                {isFetching ? 'Downloading...' : 'Download'}
            </button>

        </div>


    </div>
}


export default DisplayInputFile;